//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

import { InsertionPoint } from "./InsertionPoint";

/**
 * The dictation type.
 */
export interface Dictation {
    /**
     * The insertion point.
     */
    insertionPoint: InsertionPoint;
}
